const config = {
  API_URL: process.env.REACT_APP_API_URL || 
    (process.env.NODE_ENV === 'production' 
      ? 'https://makana.julianvalencia.shop/api'
      : 'http://localhost:5501/api')
};

export { config };